/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import EditableCard from 'modules/common/editableCard.component';

const FeeInfoCard = props => {
  const {
    feeRecordDetails,
    feeRule,    
    enumerations,
    isLoading
  } = props;

  const feeTypes =
    enumerations && enumerations.feeBatchTypes && enumerations.feeBatchTypes.length > 0
      ? enumerations.feeBatchTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

 const feeStatuses =
    enumerations && enumerations.feeStatuses && enumerations.feeStatuses.length > 0
      ? enumerations.feeStatuses.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const feeStatusReasons =
      enumerations && enumerations.feeStatusReasons && enumerations.feeStatusReasons.length > 0
        ? enumerations.feeStatusReasons.filter(s => s.isActive === true)
        : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const feeFrequencies =
    enumerations && enumerations.feeFrequencies && enumerations.feeFrequencies.length > 0
      ? enumerations.feeFrequencies.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const feeInfoTab = [
    { header: 'Fee Details', order: 1, iconPath: ['fa', 'file-invoice-dollar'] }
  ];

  const feeInfo = feeRecordDetails ? {
    feeName: feeRule ? feeRule.feeLineDescription : '',
    feeType: feeTypes ? feeTypes.find(t => t.id === feeRecordDetails.feeBatchTypeId)?.title : '',
    fixedPercentage: feeRule ? feeRule.isPercentage : false,
    feeAmount: feeRule ? feeRule.feeAmount : null,
    frequency: feeFrequencies && feeRule ? feeFrequencies.find(f => f.id === feeRule.feeFrequencyId)?.title : '',
    feeStatus: feeStatuses ? feeStatuses.find(s => s.id === feeRecordDetails.feeStatusId)?.title : '',
    feeStatusReason: feeStatusReasons ? feeStatusReasons.find(r => r.id === feeRecordDetails.feeStatusReasonId)?.title : '',
    otherReason: feeRecordDetails ? feeRecordDetails.feeStatusReasonComment : ''
  } : {};

    const feeInfoSummaries = [
    { header: 'Fee Name', accessorKey: 'feeName', type: 'text', required: true,  value: feeInfo ? feeInfo.feeName : '', tab: 1, },
    { header: 'Fee Type', accessorKey: 'feeType', type: 'text', required: false, value: feeInfo ? feeInfo.feeType : '', tab: 1},
    { header: 'Fixed/Percentage', accessorKey: 'fixedPercentage', type: 'checkbox',  required: false, value: feeInfo ? feeInfo.fixedPercentage : '', tab: 1 },
    { header: 'Fee Amount', accessorKey: 'feeAmount', type: 'money', required: false, value: feeInfo ? feeInfo.feeAmount : '', tab: 1 },
    { header: 'Frequency', accessorKey: 'frequency', type: 'text', required: false, value:  feeInfo ? feeInfo.frequency : '', tab: 1 },
    { header: 'Fee Status', accessorKey: 'feeStatus', type: 'text', required: false, value: feeInfo ? feeInfo.feeStatus : '', tab: 1 },
    { header: 'Fee Status Reason', accessorKey: 'feeStatusReason', type: 'text', required: false, value: feeInfo ? feeInfo.feeStatusReason : '', tab: 1 },
    { header: 'Other Reason', accessorKey: 'otherReason', type: 'text', required: false, value: feeInfo ? feeInfo.otherReason : '',       
      showWhen: () => {
        return feeInfo && feeInfo.feeStatusReason === 'Other';
      }, tab: 1 }
  ];

  return (
      <EditableCard
        tabs={feeInfoTab}
        summaries={feeInfoSummaries}
        numColumns={4} 
        isReadOnly={true}
        hideEdit={true}
        isLoading={isLoading}
      />
    );
  
};

export default FeeInfoCard;
